(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    let mobile = false;
    if (window.innerWidth < 1000) {
        mobile = true;
    }

    let productsToAdd = [];

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    let orderV3BExists;

    /************
     Product Swiper
     ************/
    const thumbSwiper = new Swiper(section.querySelector(".productV3ContentMediaThumbs"), {
        spaceBetween: 5,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            1000: {
                spaceBetween: 8,
            }
        },
        mousewheel: {
            forceToAxis: true
        }
    });
    const productSwiper = new Swiper(section.querySelector(".productV3ContentMediaGallery"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
            el: section.querySelector("#productV3ContentMediaGalleryBullets"),
            clickable: true,
        },
        thumbs: {
            swiper: thumbSwiper,
        },
        navigation: {
            nextEl: section.querySelector(".productV3ContentMediaGalleryNext"),
            prevEl: section.querySelector(".productV3ContentMediaGalleryPrev"),
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });


    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(e => console.error(e));
        });
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        if (section.querySelector(".productV3BOrder").classList.contains("active")) {
            return !!section.querySelector(`.productV3BOrderLabelInput[value="sub"]:checked`)
        }
        return !!section.querySelector(`.productV3OrderLabelInput[value="sub"]:checked`);
    }

    async function updateProduct() {
        productsToAdd = [];

        //orderV3BExists = section.querySelector(".productV3BOrder").classList.contains("active") ?? false;

        // THIS HANDLES THE DIFFERENT FRAGRANCES IF THAT'S AN OPTION
        section.querySelectorAll('.productV3OptionsItem').forEach(item => {
            const variant = JSON.parse(item.dataset.variant);
            const quantity = parseInt(item.dataset.quantity);

            //OBJECT FOR ORDER INFORMATION
            let productData = {
                id: variant.id,
                quantity: quantity,
                price: variant.price,
                subscription_price: variant.price * 0.85,
                compare_price: variant.compare_at_price
            }
            // CHECK FOR SUBSCRIPTION AND WHAT PLAN IT HOLDS
            section.querySelectorAll(".productV3OrderLabelInput").forEach(item => {
                // CHECK FOR SUBSCRIPTION OR ONE TIME PURCHASE
                if (item.checked && item.value === "sub") {
                    let plan = section.querySelector(".productV3OrderDropSelect");
                    productData["selling_plan"] = plan.value;
                }
            });

            section.querySelectorAll(".productV3BOrderLabelInput").forEach(item => {
                // CHECK FOR SUBSCRIPTION OR ONE TIME PURCHASE
                if (item.checked && item.value === "sub") {
                    let plan = section.querySelector(".productV3BOrderLabelDropWrapContentLabelSelect");
                    productData["selling_plan"] = plan.value;
                }
            });

            // Build the maps from the blocks
            let discountMap = {}
            let ppuMap = {};
            let subDiscount = 1;
            let subDiscountPct = 0;

            // Calculate the selling plan discount
            product.selling_plan_groups.forEach((group) => {
                group.selling_plans.forEach(plan => {
                    if (plan.id === parseInt(section.querySelector(".productV3OrderDropSelect").value)) {
                        subDiscountPct = plan.price_adjustments[0].value;
                        subDiscount = 1.00 - (plan.price_adjustments[0].value / 100);
                    }
                });
            });

            // Build the discount maps — store raw integer percent so we can mirror Shopify's floor arithmetic
            section.querySelectorAll(".productV3TiersBottomItemValue").forEach(item => {
                discountMap[parseInt(item.dataset.quantity)] = parseInt(item.dataset.percent);
                ppuMap[parseInt(item.dataset.index)] = 1.00 - parseInt(item.dataset.percent) / 100;
            });


            // if quantity > 0, add it to the productsToAdd array
            if (quantity > 0) {
                productsToAdd.push(productData);

                // Total the prices
                let priceTotal = 0;
                //  Determine the current tier
                let totalQuantity = 0;

                for (const item of productsToAdd) {
                    priceTotal += item.price * item.quantity;
                    totalQuantity += item.quantity;
                }

                // Calculate the Bundle Discount
                section.querySelectorAll(".productV3TiersBottomItemValue").forEach(ppu => {
                    if (section.querySelector(".productV3OrderLabelInput:checked").value === "sub") {
                        ppu.textContent = price(variant.price * ppuMap[ppu.dataset.index] * subDiscount);
                    } else {
                        ppu.textContent = price(variant.price * ppuMap[ppu.dataset.index]);
                    }
                });

                // Get the correct discount percent
                let discountPct = 0;
                if (totalQuantity >= 6) {
                    discountPct = discountMap[6];
                } else if (totalQuantity >= 3) {
                    discountPct = discountMap[3];
                } else {
                    discountPct = discountMap[totalQuantity] || 0;
                }
                let discountAmount = 0;
                for (const item of productsToAdd) {
                    discountAmount += Math.floor(item.price * discountPct / 100) * item.quantity;
                }
                priceTotal -= discountAmount;

                //Enable the ATC button
                section.querySelector(".productV3CartButton").disabled = false;

                // Shopify selling plan rounds the unit price and bundle discount applies per unit
                let subPrice = 0;
                for (const item of productsToAdd) {
                    const subUnitPrice = Math.round(item.price * (1 - subDiscountPct / 100));
                    subPrice += (subUnitPrice - Math.floor(subUnitPrice * discountPct / 100)) * item.quantity;
                }
                let otpPrice = priceTotal;

                // Update the price display in ATC button and radio buttons
                //Order buttons variant (new)
                section.querySelector(".productV3BOrderLabelContentPrice.otp").textContent = `${price(otpPrice)}`;
                section.querySelector(".productV3BOrderLabelContentPrice.sub").textContent = `${price(subPrice)}`;
                section.querySelector(".productV3BOrderLabelContentPriceCompare.sub").textContent = `${price(otpPrice)}`;

                //Order Buttons Base
                section.querySelector(".productV3OrderLabelBodyPrice.otp").textContent = `${price(otpPrice)}`;
                section.querySelector(".productV3OrderLabelBodyPrice.sub").textContent = `${price(subPrice)}`;
                section.querySelector(".productV3OrderLabelBodyCompare.sub").textContent = `${price(otpPrice)}`;

                section.querySelectorAll(".productV3OrderLabelInput").forEach(item => {
                    if (isSubscription()) {
                        section.querySelector(".productV3CartButton").textContent = `ADD TO CART • ${price(subPrice)}`;
                    } else {
                        section.querySelector(".productV3CartButton").textContent = `ADD TO CART • ${price(otpPrice)}`;
                    }
                });
                section.querySelectorAll(".productV3OrderLabelBodyDot").forEach(item => {
                    item.classList.add("active");
                });

                // ANIMATE BAR FOR TIER SYSTEM
                const barItems = section.querySelectorAll(".productV3TiersBarsItem");
                let barItemsIndex = 0;
                barItems.forEach(item => {
                    barItemsIndex++;
                    // COLOR IN THE CIRCLES AT AND BEYOND EVERY TIER
                    if (totalQuantity >= parseInt(item.dataset.quantity)) {
                        item.querySelector(".productV3TiersBarsItemCircle").classList.add("active");
                        item.querySelector(".productV3TiersBarsItemCircleInner").classList.add("active");
                    } else {
                        item.querySelector(".productV3TiersBarsItemCircle").classList.remove("active");
                        item.querySelector(".productV3TiersBarsItemCircleInner").classList.remove("active");
                    }
                    // ONLY COLOR THE BARS IF WE HAVE PASSED THE MOST RECENT TIER
                    if (item !== barItems[barItems.length - 1]) { // prevent an index error when we get to the end
                        // Compare the current quantity to the next tier up.
                        if (totalQuantity >= parseInt(barItems[barItemsIndex].dataset.quantity)) {
                            item.querySelector(".productV3TiersBarsItemLineInner").classList.add("active");
                        } else {
                            item.querySelector(".productV3TiersBarsItemLineInner").classList.remove("active");
                        }
                    }
                });
            }
            let totalQuantity = 0;
            for (let item of section.querySelectorAll(".productV3OptionsItem")) {
                totalQuantity += parseInt(item.dataset.quantity);
            }
            if (totalQuantity === 0) {
                section.querySelectorAll(".productV3TiersBarsItem").forEach(option => {
                    option.querySelector(".productV3TiersBarsItemCircle").classList.remove("active");
                    option.querySelector(".productV3TiersBarsItemCircleInner").classList.remove("active");
                });
            }
        });
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /**************
     Product Quantity
     ***************/
    section.querySelectorAll(".productV3OptionsItem").forEach(element => {
        // HANDLES THE 'ADD' BUTTON; MAKES DISAPPEAR ON CLICK AND INITs QUANTITY
        element.querySelector(".productV3OptionsItemControlsAdd").addEventListener("click", (e) => {
            e.target.classList.remove("active");
            element.querySelector(".productV3OptionsItemControlsQuantity").classList.add("active");
            element.dataset.quantity = "1";
            element.querySelector(".productV3OptionsItemControlsQuantityValue").textContent = element.dataset.quantity;
            updateProduct().catch(e => console.error(e));

            //Auto swipe to image
            if (JSON.parse(element.dataset.variant).featured_image) {
                // change active slide
                productSwiper.slideToLoop(JSON.parse(element.dataset.variant).featured_image.position - 1);
            }
        });


        // // minus
        element.querySelector(".productV3OptionsItemControlsQuantityBtn.minus")?.addEventListener("click", function () {
            if (parseInt(element.dataset.quantity) <= 1) {
                // Close the controls
                element.querySelector(".productV3OptionsItemControlsQuantity").classList.remove("active");
                // show the 'ADD' button again.
                element.querySelector(".productV3OptionsItemControlsAdd").classList.add("active");
                // Reset price sections
                section.querySelector(".productV3OrderLabelBodyPrice.otp").textContent = "";
                section.querySelector(".productV3OrderLabelBodyPrice.sub").textContent = "";
                section.querySelector(".productV3OrderLabelBodyCompare.sub").textContent = "";

                // New Buy buttons
                section.querySelector(".productV3BOrderLabelContentPrice.otp").textContent = ``;
                section.querySelector(".productV3BOrderLabelContentPrice.sub").textContent = ``;
                section.querySelector(".productV3BOrderLabelContentPriceCompare.sub").textContent = ``;

                section.querySelectorAll(".productV3CartButton").forEach(button => {
                    button.textContent = "SELECT PRODUCTS";
                    button.disabled = true;
                });
                //Turn off the dots
                section.querySelectorAll(".productV3OrderLabelBodyDot").forEach(item => {
                    item.classList.remove("active");
                })
                element.dataset.quantity--;
                updateProduct().catch(e => console.error(e));
                return
            }
            element.dataset.quantity--;
            element.querySelector(".productV3OptionsItemControlsQuantityValue").textContent = element.dataset.quantity;
            updateProduct().catch(e => console.error(e));
        });

        // plus
        element.querySelector(".productV3OptionsItemControlsQuantityBtn.plus")?.addEventListener("click", function () {
            element.dataset.quantity++;
            element.querySelector(".productV3OptionsItemControlsQuantityValue").textContent = element.dataset.quantity;
            updateProduct().catch(e => console.error(e));
        });
    });

    /**************
     Radio Listener
     ***************/
    section.querySelectorAll(".productV3OrderLabelInput").forEach(element => {
        element.addEventListener("change", (e) => {
            // Remove the active classes on the drop and the radio button
            section.querySelectorAll(".productV3OrderWrapper").forEach(item => {
                item.classList.remove("active");
            });
            if (e.target.checked) {
                // Set the checked radio to active
                e.target.parentElement.parentElement.classList.add("active");
            }
            updateProduct().catch(e => console.error(e));
        });
    });
    /**************
     Pack Selector Listener
     ***************/
    section.querySelectorAll(".productV3OptionsPacksItemInput").forEach(element => {
        element.addEventListener("change", (e) => {
            updateProduct().catch(e => console.error(e));
        })
    });

    /**************
     Returns Footnote listener
     ***************/
    section.querySelector(".productV3Footnote").addEventListener("click", (e) => {
        section.querySelector(".productV3FootnotePopup").showModal();
    });
    section.querySelector(".productV3FootnotePopupClose").addEventListener("click", (e) => {
        section.querySelector(".productV3FootnotePopup").close();
    });

    /**************
     Ingredients Button listener
     ***************/
    const ingredientsPopup = section.querySelector(`[id="${product.id}-ingredientsPopupV2"]`) || false
    if (ingredientsPopup) {

        //Animation listner to determine if we animated in or our
        ingredientsPopup.addEventListener("animationend", (e) => {
            if (e.animationName === "popupIn") {
                ingredientsPopup.classList.remove("popupIn");
            } else if (e.animationName === "popupOut") {
                ingredientsPopup.close();
                ingredientsPopup.classList.remove("popupOut");
            }
        });

        //Show the modal
        section.querySelector(".productV3Ingredients").addEventListener("click", (e) => {
            ingredientsPopup.classList.add("popupIn");
            ingredientsPopup.showModal();
        });

        //Hide the modal on close button click
        ingredientsPopup.querySelector(".ingredientsPopupV2Close").addEventListener("click", (e) => {
            ingredientsPopup.classList.add("popupOut");
        });
        //hide the modal if background is clicked
        ingredientsPopup.addEventListener("click", (e) => {
            if (e.target === ingredientsPopup) {
                ingredientsPopup.classList.add("popupOut");
            }
        });
    }


    /**************
     Mobile ATC Listener to sticky button
     ***************/
    let atcParent = section.querySelector(".productV3Cart");
    window.addEventListener("scroll", (e) => {
        if (atcParent.getBoundingClientRect().top <= 0) {
            section.querySelector(".productV3CartButton").classList.add("stick");
        } else {
            section.querySelector(".productV3CartButton").classList.remove("stick");
        }
    })


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV3CartButton").classList.add("loading");

        let formData = {
            items: productsToAdd
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV3CartButton").classList.remove("loading");

        // open cart
        await openCart();

        //OPEN THE UPSELL
        openUpsell(product.id);
    }

    section.querySelector('.productV3CartButton').addEventListener("click", addToCart);
}());